import type { WorkspaceMember } from '../api';

/** A mention being typed: the text after the `@` and the range it covers. */
export interface MentionQuery {
  /** The text typed after the `@`. */
  query: string;
  /** Document position of the `@` itself. */
  from: number;
  /** Document position just after the typed text. */
  to: number;
}

/**
 * The mention being typed at the end of a text block, if any.
 *
 * Only a plain text block qualifies: the offsets in the text and the positions
 * in the document are then the same, which keeps the replacement exact.
 */
export function mentionQueryAt(
  text: string,
  cursorOffset: number,
  blockStart: number,
): MentionQuery | null {
  const before = text.slice(0, cursorOffset);
  const match = /(^|\s)@([^\s@]*)$/.exec(before);
  if (!match) return null;
  const query = match[2] ?? '';
  const at = (match.index ?? 0) + (match[1] ?? '').length;
  return { query, from: blockStart + at, to: blockStart + before.length };
}

/** The members whose name starts with what the user typed. */
export function filterMembers(members: WorkspaceMember[], query: string): WorkspaceMember[] {
  const needle = query.trim().toLowerCase();
  const named = members.filter((member) => member.name);
  if (!needle) return named;
  return named.filter((member) => member.name.toLowerCase().includes(needle));
}
